<ng-container *ngIf="currentBlogSection === 'MAIN'; then BlogCreateArea; else MetaCreateArea"></ng-container>

<ng-template #BlogCreateArea>
  <section class="blog-create-area">
    <!-- Header -->
    <div class="header-main-section">
      <div class="header-inner d-flex align-items-center justify-content-between">
        <div class="header-title-group d-flex align-items-center gap-2">
          <div class="header-icon-box d-flex align-items-center justify-content-center">
            <mat-icon>tune</mat-icon>
          </div>
          <div class="header-text">Blog Settings</div>
        </div>
        <button type="button" class="close-btn d-flex align-items-center justify-content-center" (click)="closeDialog()" title="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Fields Content -->
    <div class="content-fields">
      <div class="field">
        <label class="lead-heading">Post Title <span class="required-star">*</span></label>
        <div class="input-container">
          <input matInput placeholder="e.g. 10 Strategies for Business Growth" [(ngModel)]="blog.postTitle" />
        </div>
      </div>

      <div class="field">
        <label class="lead-heading">Blog Slug <span class="required-star">*</span></label>
        <div class="input-container slug-input-wrapper">
          <span class="slug-prefix">/blogs/</span>
          <input matInput placeholder="enter-article-slug" [(ngModel)]="blog.articleSlug" />
        </div>
      </div>

      <div class="field">
        <label class="lead-heading">Post Summary <span class="required-star">*</span></label>
        <div class="input-container">
          <textarea matInput rows="3" placeholder="Provide a short, engaging description for readers..." [(ngModel)]="blog.postSummary"></textarea>
        </div>
      </div>

      <div class="field">
        <label class="lead-heading">Tags</label>
        <mat-form-field class="custom-mat-form-field simpo-mat-chip" appearance="outline" [formControl]="tagControl">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let item of filteredTags" [value]="item.tagName" (click)="addTag(item.tagName, TagInput)">
              {{ item.tagName }}
            </mat-option>
            <mat-option *ngIf="tagControl.value && showAddTagOption" (click)="addTagThroughApi(TagInput)">
              <div class="text-secondary">Add <span class="text-dark font-weight-bold">"{{ tagControl.value }}"</span></div>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #tagsChipGrid aria-label="Tags selection">
            <mat-chip-row class="mat-chip" *ngFor="let tag of tags" (removed)="removeTag(tag)">
              <strong>{{ tag }}</strong>
              <button matChipRemove [attr.aria-label]="'remove ' + tag">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            <input placeholder="Add Tag..." [formControl]="tagControl" [matChipInputFor]="tagsChipGrid"
              [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addNewTag($event)" #TagInput style="width: 100%;" />
          </mat-chip-grid>
        </mat-form-field>
      </div>

      <div class="field">
        <label class="lead-heading">Author</label>
        <mat-form-field class="custom-mat-form-field simpo-mat-chip" appearance="outline">
          <mat-chip-grid #authorChipGrid aria-label="Author selection">
            <mat-chip-row class="mat-chip" *ngFor="let author of authors" (removed)="removeAuthor(author)">
              <strong>{{ author }}</strong>
              <button matChipRemove [attr.aria-label]="'remove ' + author">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            <input placeholder="Pick author..." aria-label="Author" [formControl]="authorControl" [matAutocomplete]="auto1"
              [matChipInputFor]="authorChipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addNewAuthor($event)" #AuthorInput style="width: 100%;">
          </mat-chip-grid>
          <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
            <mat-option *ngFor="let option of filteredAuthors" [value]="option.authorName"
              (click)="addAuthor(option.authorName, AuthorInput)">
              {{option.authorName}}
            </mat-option>
            <mat-option *ngIf="authorControl.value && showAddAuthorOption" (click)="addAuthorThroughApi(AuthorInput)">
              <div class="text-secondary">Add <span class="text-dark font-weight-bold">"{{ authorControl.value }}"</span></div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="field">
        <label class="lead-heading">Category</label>
        <div class="field-dd category-field-dd" [class.open]="categoryDropdownOpen">
          <button type="button" class="field-dd-trigger" (click)="toggleCategoryDropdown()">
            <span>{{ getSelectedCategoryName() }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
              stroke-linejoin="round" width="13" height="13">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="field-dd-panel" *ngIf="categoryDropdownOpen">
            <div class="field-dd-row" [class.selected]="!blog.categoryId" (click)="selectCategoryOption(null)">
              None / Uncategorized
            </div>
            <div class="field-dd-row" *ngFor="let category of categories"
              [class.selected]="blog.categoryId === category.id" (click)="selectCategoryOption(category)">
              {{ category.categoryName }}
            </div>
            <div class="field-dd-empty" *ngIf="!categories.length">No categories yet</div>
          </div>
        </div>
      </div>

      <!-- SEO Meta Card Link -->
      <div class="meta-card-link d-flex align-items-center justify-content-between cursor-pointer" (click)="toggleMetaCardView()">
        <div class="meta-left d-flex align-items-center gap-3">
          <div class="seo-icon-box d-flex align-items-center justify-content-center">
            <mat-icon class="seo-icon">search</mat-icon>
          </div>
          <div class="seo-details">
            <div class="seo-title d-flex align-items-center gap-2">
              <span>SEO & Meta Information</span>
              <span class="status-pill active" *ngIf="blog.blogMeta?.metaTitle || blog.blogMeta?.metaDescription?.content">
                <mat-icon class="check-icon">check_circle</mat-icon> Configured
              </span>
              <span class="status-pill pending" *ngIf="!blog.blogMeta?.metaTitle && !blog.blogMeta?.metaDescription?.content">
                Recommended
              </span>
            </div>
            <div class="seo-subtitle">Optimize meta title, description & search snippet preview</div>
          </div>
        </div>
        <div class="meta-arrow d-flex align-items-center">
          <mat-icon>chevron_right</mat-icon>
        </div>
      </div>
    </div>

    <!-- Fixed Bottom Footer Button -->
    <div class="buttons-section">
      <button type="button" (click)="saveBlogSettings()" *ngIf="!data?.edit"
        [disabled]="!blog.postTitle || !blog.postSummary || !blog.articleSlug || addLoader" class="save-settings-btn">
        <span *ngIf="addLoader" class="d-flex align-items-center justify-content-center gap-2">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Saving Settings...
        </span>
        <span *ngIf="!addLoader">Save Settings</span>
      </button>
    </div>
  </section>
</ng-template>

<ng-template #MetaCreateArea>
  <section class="blog-create-area">
    <!-- Header -->
    <div class="header-main-section">
      <div class="header-inner d-flex align-items-center justify-content-between">
        <div class="header-text d-flex align-items-center gap-2 cursor-pointer" (click)="toggleMetaCardView()">
          <mat-icon class="back-icon">arrow_back</mat-icon>
          <span>SEO Settings</span>
        </div>
        <button type="button" class="done-btn" (click)="saveMetaInformation()">Done</button>
      </div>
    </div>

    <!-- Form -->
    <form class="content-fields" [formGroup]="metaForm">
      <div class="field">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <label class="lead-heading m-0">Meta Title</label>
          <span class="char-count" [class.optimal]="(blog.blogMeta?.metaTitle?.length || 0) <= 60 && (blog.blogMeta?.metaTitle?.length || 0) > 0">
            {{ blog.blogMeta?.metaTitle?.length || 0 }}/60 chars
          </span>
        </div>
        <div class="input-container">
          <input matInput placeholder="Add meta title for search engines" formControlName="metaTitle" [(ngModel)]="blog.blogMeta.metaTitle" />
        </div>
      </div>

      <div class="field">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <label class="lead-heading m-0">Meta Description</label>
          <span class="char-count" [class.optimal]="(blog.blogMeta?.metaDescription?.content?.length || 0) <= 140 && (blog.blogMeta?.metaDescription?.content?.length || 0) > 0">
            {{ blog.blogMeta?.metaDescription?.content?.length || 0 }}/140 chars
          </span>
        </div>
        <div class="input-container">
          <textarea matInput rows="3" placeholder="Add meta description snippet..." formControlName="metaDescription"
            [(ngModel)]="blog.blogMeta.metaDescription.content"></textarea>
        </div>
      </div>

      <!-- Google Search Preview Card -->
      <div class="field mt-3">
        <label class="lead-heading">Google Search Snippet Preview</label>
        <div class="google-preview-card">
          <div class="google-header d-flex align-items-center gap-2 mb-2">
            <div class="google-logo d-flex align-items-center justify-content-center">
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
              </svg>
            </div>
            <div class="google-url-strip text-truncate">
              <span class="domain-text">{{ businessWebsiteUrl || 'https://yourwebsite.com' }}</span>
              <span class="url-path"> › blogs › {{ blog.articleSlug || 'post-title' }}</span>
            </div>
          </div>
          <div class="google-title text-truncate">
            {{ blog.blogMeta?.metaTitle || blog.postTitle || 'Blog Article Title - Website Name' }}
          </div>
          <div class="google-desc">
            {{ blog.blogMeta?.metaDescription?.content || blog.postSummary || 'Add a compelling meta description to improve click-through rates from search engine results...' }}
          </div>
        </div>
      </div>
    </form>
  </section>
</ng-template>